import { Div } from '@kizi/core-components';
import React from 'react';
import { FormPropsWithValue } from '../HOCs';
import { AdditionalCoverageItem, AdditionalCoverageItemProps } from './Item';

export interface AdditionalCoverageListProps extends FormPropsWithValue {
  items: AdditionalCoverageItemProps[];
}

export const AdditionalCoverageList: React.VFC<AdditionalCoverageListProps> = ({
  items,
  ...input
}) => {
  const value = React.useMemo(() => new Set(input.value || []), [input.value]);
  const onChange = React.useCallback<
    React.ChangeEventHandler<HTMLInputElement>
  >(
    (event) => {
      if (event.target.checked) {
        value.add(event.target.value);
      } else {
        value.delete(event.target.value);
      }
      input.onChange?.({
        ...event,
        target: {
          name: input.name,
          value: Array.from(value),
        },
      });
    },
    [value, input.onChange, input.name],
  );
  return (
    <Div
      display="grid"
      gridGap={[4, null, 6]}
      data-testid="AdditionalCoverageList"
    >
      {items.map((item, idx) => (
        <AdditionalCoverageItem
          {...item}
          checkbox={{
            ...item.checkbox,
            name: input.name,
            checked: value.has(item.checkbox.value),
            onChange,
          }}
          key={idx}
          data-testid="AdditionalCoverageList.item"
        />
      ))}
    </Div>
  );
};
